///<reference path="../../../../typings/index.d.ts" />
///<reference path="../../components/baseClasses/dataMaintenanceContextBase.ts"/>
///<reference path="../../components/baseClasses/dataMaintenanceSectionBase.ts"/>
///<reference path="../../components/baseclasses/guid.ts" />
///<reference path="../../components/models/meevo.model.custom.ts" />
///<reference path="../../components/common/security.parts.ts"/>
///<reference path="../employee/employee.context.ts"/>
///<reference path="sections/teachers.main.section.ts"/>
///<reference path="sections/teachers.location.section.ts"/>
///<reference path="sections/teachers.services.section.ts"/>
///<reference path="sections/teachers.shared.section.ts"/>
///<reference path="sections/teachers.licensesInsurance.section.ts"/>
///<reference path="sections/teachers.compensation.section.ts"/>
///<reference path="sections/teachers.deduction.section.ts"/>
///<reference path="sections/teachers.bookingRestrictions.section.ts"/>
///<reference path="sections/teachers.serviceCommissions.section.ts"/>
///<reference path="sections/teachers.ImageGallery.section.ts"/>
///<reference path="sections/teachers.notes.section.ts"/>


module Meevo.Plugins.Teachers {
    'use strict';
    
    export class TeachersContext extends Meevo.Plugins.Employee.EmployeeContext {
        private teacherEndPoint: string = "";
        get pluginFolder() {
            return 'teachers';
        }

        protected get contextMessages(): Meevo.Plugins.Employee.IContextMessages {
            return {
                sectionMain: 'SECTION_TEACHERS_MAIN',
                activateUser: 'MESSAGE_ACTIVATE_TEACHER_CONFIRMATION',
                activateUserWithPromo: 'MESSAGE_INACTIVATE_TEACHER_WITH_PROMO_CONFIRMATION',
                clientLinkConfirmation: 'MESSAGE_TEACHER_CLIENT_LINK_CONFIRMATION',
                terminateWithPromo: 'MESSAGE_TERMINATE_TEACHER_WITH_PROMO_CONFIRMATION',
                terminateConfirmation: 'MESSAGE_TERMINATE_TEACHER_CONFIRMATION',
                deleteWithPromoConfirm: 'MESSAGE_DELETE_TEACHER_WITH_PROMO_CONFIRMATION',
                deleteConfirm: 'MESSAGE_DELETE_EMPLOYEE_CONFIRMATION',
                deleteFutureWorkTimeConfirm: 'MESSAGE_DELETE_FUTURE_WORKTIME_TEACHER_CONFIRM',
                deleteFutureBlockTimeConfirm: 'MESSAGE_DELETE_FUTURE_BLOCKTIME_TEACHER_CONFIRM',
                applyTemplateConfirm: 'MESSAGE_CONFIRM_APPLY_TEMPLATE_ON_TEACHER',
                cannotTemplateNew: 'MESSAGE_TEACHER_CANNOT_TEMPLATE_NEW',
            }
        }
        initializeContext(): void {
            // initialize templatepaths
            this.sectionTemplatePath = 'app/plugins/teachers/sectionViews/';
            // Teacher end point for the Main Tab
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.employee;
            // Employee end point for the other tabs
            this.teacherEndPoint = this.appSettings.API_ENDPOINTS.teachers;

        }

        initializeSections(): void {
            this.initializeContext()
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_TEACHER_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(
                    new MainSection(
                        0,
                        'SECTION_TEACHERS_MAIN',
                        'main.html',
                        true,
                        false,
                        this.teacherEndPoint,
                        '',
                        this.loggingService,
                        this.dataService,
                        this.identityService,
                        Model.NounEnum.TeacherMain,
                        this.appSettings,
                        this.asLocationId,
                        this.securityKeys.DATA_TEACHER_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        this.modalService,
                        this

                    )
                );
            } else {
                this.mainTabAccessHide = true;
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_TEACHER_TAB_LOCATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new LocationSection(1,
                    'SECTION_TEACHERS_LOCATIONS',
                    'locations.html',
                    false,
                    false,
                    '',
                    'security',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.TeacherSecurity,
                    null,
                    this.securityKeys.DATA_TEACHER_TAB_LOCATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.$translate,
                    this.modalService,
                    this
                ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_TEACHER_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ServicesSection(2,
                    'SECTION_TEACHERS_SERVICES',
                    'services.html',
                    false,
                    false,
                    '',
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.TeacherServices,
                    this.appSettings,
                    this.securityKeys.DATA_TEACHER_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.securityChecker));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_TEACHER_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && !this.identityService.inCentralOfficeMode())
                this.sections.push(new CompensationSection(3,
                    'SECTION_TEACHERS_COMPENSATION',
                    'compensation.html',
                    false,
                    false,
                    '',
                    'compensation',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.TeacherCompensation,
                    this.modalService,
                    this.appSettings,
                    this.securityKeys.DATA_TEACHER_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_TEACHER_TAB_DEDUCTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && !this.identityService.inCentralOfficeMode())
                this.sections.push(new DeductionSection(4,
                    'SECTION_TEACHERS_DEDUCTION',
                    'deduction.html',
                    false,
                    false,
                    '',
                    'deduction',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.TeacherDeductions,
                    null,
                    this.securityKeys.DATA_TEACHER_TAB_DEDUCTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_TEACHER_TAB_SERVICECOMMISSIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ServiceCommissionsSection(5,
                    'SECTION_TEACHERS_SERVICE_COMMISSIONS_OVERRIDE',
                    'servicesCommissions.html',
                    false,
                    false,
                    this.baseEndpoint,
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.TeacherCommissionOverrides,
                    null,
                    this.securityKeys.DATA_TEACHER_TAB_SERVICECOMMISSIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_TEACHER_TAB_ONLINEBOOKING + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new OnlineBookingSection(6,
                    "SECTION_TEACHERS_ONLINEBOOKING",
                    "OnlineBooking.html",
                    false,
                    false,
                    this.teacherEndPoint,
                    "OnlineBooking",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.TeacherOnlineBooking,
                    this.modalService,
                    this.securityKeys.DATA_TEACHER_TAB_ONLINEBOOKING + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_TEACHER_TAB_BOOKINGRESTRICTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new BookingRestrictionsSection(7,
                    'SECTION_TEACHERS_BOOKING_RESTRICTIONS',
                    'bookingRestrictions.template.html',
                    false,
                    false,
                    '',
                    'BookingRestrictions',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.TeacherBookingRestrictions,
                    this.modalService,
                    this.securityKeys.DATA_TEACHER_TAB_BOOKINGRESTRICTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_TEACHER_TAB_LICENSESINSURANCE + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new LicensesInsuranceSection(8,
                    'SECTION_TEACHERS_LICENSE_INSURANCE',
                    'licensesInsurance.html',
                    false,
                    true,
                    '',
                    'licensesinsurances',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.TeacherLicenseInsurance,
                    this.modalService,
                    this.securityKeys.DATA_TEACHER_TAB_LICENSESINSURANCE + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_TEACHER_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ImageGallerySection(9,
                    'SECTION_IMAGE_GALLERY',
                    'imageGallery.html',
                    false,
                    true,
                    '',
                    'imagegallery',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.TeacherImageGallery,
                    this.modalService,
                    this.imageGalleryService,
                    this.securityKeys.DATA_TEACHER_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_TEACHER_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new NotesSection(10,
                    'SECTION_CLIENT_NOTES',
                    'notes.html',
                    false,
                    true,
                    '',
                    'notes',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.TeacherNotes,
                    this.modalService,
                    this.securityKeys.DATA_TEACHER_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.customDataContextConfig && this.customDataContextConfig.appAreaTabs.length > 0) {
                this.renderCustomSections();
            }
        }

        selectSection(item): void {

            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_TEACHER_TAB_LOCATIONS);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_TEACHER_TAB_SERVICES);
                    break;
                case 3:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_TEACHER_TAB_PAYROLL);
                    break;
                case 4:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_TEACHER_TAB_DEDUCTION);
                    break;
                case 5:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_TEACHER_TAB_SERVICECOMMISSIONS);
                    break;
                case 6:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_TEACHER_TAB_ONLINEBOOKING);
                    break;
                case 7:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_TEACHER_TAB_BOOKINGRESTRICTION);
                    break;
                case 8:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_TEACHER_TAB_LICENSESINSURANCE);
                    break;
                case 9:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_TEACHER_TAB_IMAGEGALLERY);
                    break;
                case 10:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_TEACHER_TAB_NOTES);
                    break;
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_TEACHER_TAB_MAIN, true, true);
                    this.loadNotificationSetting();
                    if (this.itemId) {
                        this.loadRating();
                    }
                    break;
            }
            if (this.mainTabAccessHide) {
                this.dataService.getSectionById(this.baseEndpoint, this.itemId, '', this.asLocationId).then((data: Model.Employee) => {
                    this.initializeHeader(data);
                });
                this.mainTabAccessHide = false;
            }

            super.byPassEmployeeSelectSection(item);
        }

        initializeHeader(model: any): void {

            if (!this.isAdding)
                this.headerContent = model.isLocationEmployee ? model.lastName + ', ' + model.firstName : model.userName;

            var canAppendLocationId = !this.isApplicationModeCO() && (this.identityService.current().callCenterId !== this.identityService.current().locationId);

            // Get TenantDistribution model and build url
            this.dataService.customMethodData("api/tenant/businessinfo/customerportalurl", "GET", null)
                .then((result: any) => {
                    if (result && result.data && result.data.onlineBookingUrl) {
                        this.obAppTeacherUrl = result.data.onlineBookingUrl;
                    }

                    this.obAppTeacherUrl += `&empId=${this.selectedSection.model.id}&empEntityId=${Model.EmployeeEntityTypeEnum.Teacher}`;
                });
            this.visualizeTabs(model.isLocationEmployee, this.showSharedTab(model));
        }

        public visualizeTabs(isLocationEmployee: boolean, showSharedTab: boolean): void {
            let employee = <Model.Employee>this.selectedSection.model;

            this.sections.forEach(s => {
                if (s.noun === null && !employee.security.userLocations[0].location.isEmployee) {
                    s.isVisible = false;
                }
                switch (s.displayNameContentKey) {
                    case 'SECTION_TEACHERS_SERVICES':
                    case 'SECTION_TEACHERS_LICENSE_INSURANCE':
                    case 'SECTION_TEACHERS_COMPENSATION':
                    case 'SECTION_TEACHERS_DEDUCTION':
                    case 'SECTION_TEACHERS_BOOKING_RESTRICTIONS':
                    case 'SECTION_TEACHERS_SERVICE_COMMISSIONS_OVERRIDE':
                    case 'SECTION_IMAGE_GALLERY':
                    case 'SECTION_CLIENT_NOTES':
                        s.isVisible = isLocationEmployee;
                        break;
                    case 'SECTION_STUDENT_SHARED':
                        s.isVisible = showSharedTab;
                        break;
                }
            });

        }

        openTerminateEditor(context: TeachersContext, employee: Model.Employee) {
            // Initialize modal with employee resources
            const options: Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/teachers/sectionViews/terminateTemplate.html',
                clickOutsideToClose: false,
                locals: {
                    context: context,
                    employee: employee
                },
                controller: 'meevo.plugins.teachers.TerminateController',
                controllerAs: 'vm'
            };
            this.modalService.showCustom(options);
        }

        private _obAppTeacherUrl: string = '';

        get obAppTeacherUrl(): string {
            return this._obAppTeacherUrl;
        }
        set obAppTeacherUrl(value: string) {
            this._obAppTeacherUrl = value;
        }
    }
}
